// removed by extract-text-webpack-plugin
module.exports = {"actionContainer":"actionContainer_1ZNSE","brickContainer":"brickContainer_1gxyb","photo":"photo_3LYlH","empty":"empty_2fUg8","removeInnerPadding":"removeInnerPadding_3LbQJ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/favorite-picker/styles.scss
// module id = 432
// module chunks = 1